import { h, Fragment } from 'preact';
import useFormStore from '../store/useFormStore';

export default function EstimateTypeSelection() {
  const currentFranchise = useFormStore((state) => state.currentFranchise);
  const selectedEstimateType = useFormStore((state) => state.selectedEstimateType);
  const setEstimateType = useFormStore((state) => state.setEstimateType);

  const handleEstimateTypeSelect = (type) => {
    setEstimateType(type, true);
  };

  // Get form types from franchise
  const formTypes = currentFranchise?.form_type || {};
  const formTypeEntries = Object.entries(formTypes);

  return (
    <div className="estimate-type-selection">
      <div className="text-lg font-semibold mb-4">
        Estimate Type <span className="text-red-600">*</span>
      </div>

      <div className="flex flex-col gap-4 mb-8">
        {formTypeEntries.map(([key, data]) => {
          const isSelected = selectedEstimateType === key;

          return (
            <label
              key={key}
              className={`flex items-start p-6 border-2 cursor-pointer transition-all hover:shadow-md has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-black has-[:focus-visible]:ring-offset-2 ${
                isSelected
                  ? 'border-coit-success'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <div className="shrink-0 mt-1">
                <input
                  type="radio"
                  name="estimateType"
                  value={key}
                  checked={isSelected}
                  onChange={() => handleEstimateTypeSelect(key)}
                  className="sr-only"
                />
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${
                  isSelected
                    ? 'bg-coit-success border-coit-success'
                    : 'bg-white border-gray-500'
                }`}>
                  {isSelected && (
                    <div className="w-3 h-3 rounded-full bg-white"></div>
                  )}
                </div>
              </div>

              <div className="ml-4 flex-1 text-base">
                <div className="font-bold mb-1">{data.title}</div>
                <p
                  className="text-gray-700"
                  dangerouslySetInnerHTML={{ __html: data.description }}
                />
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
}
